import React from "react";
import { ChildrenElements } from "../../../globalTypes";
import {
    FormLabel,
    FormLabelProps, // Chakra UI's FormLabel props type
} from "@chakra-ui/react";

export function FormLabelEvo(
    props: {
        children?: ChildrenElements; // Existing prop
        mandatory?: boolean; // Optional "mandatory" prop
    } & FormLabelProps // Extend Chakra UI's FormLabelProps
): JSX.Element {
    return (
        <FormLabel {...props}>
            {props.children}
            {props.mandatory && <span style={{ color: 'red', paddingLeft: "5px" }}>*</span>}
        </FormLabel>
    );
}